import React from "react";
import "./STP.css";
import { HomeIcon } from "@heroicons/react/24/solid";
import { BuildingOfficeIcon, CogIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";



export default function SewageTreatment() {
  return (
    <div className="sewage-page">

      {/* Hero Section */}
      <section className="hero-stp" style={{background: "url('/images/STP.png')" ,}}>
        <div className="hero-stp-overlay">
          <h1>Sustainable Sewage Treatment for a Cleaner Tomorrow</h1>
          <p>Innovative, compliant, and eco-friendly wastewater solutions</p>
          <Link to="/contact"><button className="stp-cta">Explore Solutions</button></Link> 
        </div>
      </section>

      {/* Introduction Section */}
      <section className="intro">
        <div className="intro-text">
          <h2>Transforming Wastewater into a Sustainable Resource</h2>
          <p>
            Our sewage treatment solutions are designed to convert wastewater into reusable water,
        ensuring environmental safety and regulatory compliance. Whether for residential, commercial,
        or industrial applications, we deliver reliable systems that protect ecosystems and support
        long-term sustainability.
          </p>
          <p>Sewage treatment is the process of removing contaminants from wastewater, primarily from household sewage. It 
            includes physical, chemical, and biological processes to remove physical, chemical and biological processes to 
            remove these contaminants and produce environmentally safer treated wastewater (or treated effluent).
          </p>
        </div>
        <div className="intro-image">
          <img src="/images/stp-1.png" alt="Sewage Treatment Facility" />
        </div>
      </section>

      {/* Applications Section */}
     

<section className="applications">
  <h2>Applications</h2>
  <div className="app-grid">
    <div className="app-card">
      <HomeIcon className="app-icon" />
      <h3>Residential Communities</h3>
      <p>
        Safe sewage treatment for apartments and housing projects, ensuring cleaner surroundings and healthier living.
      </p>
    </div>

    <div className="app-card">
      <BuildingOfficeIcon className="app-icon" />
      <h3>Commercial Establishments</h3>
      <p>
        Wastewater management for offices, malls, and institutions, meeting compliance and sustainability goals.
      </p>
    </div>

    <div className="app-card">
      <CogIcon className="app-icon" />
      <h3>Industrial Operations</h3>
      <p>
        Advanced treatment systems for factories and plants, reducing environmental impact and supporting compliance.
      </p>
    </div>
  </div>
</section>

      {/* Advantages Section */}
      <section className="advantages">
  <h2>Key Benefits</h2>
  <div className="adv-grid">
    <div className="adv-card">
      <h3>🌍 Environmental Responsibility</h3>
      <p>Ensures compliance with global standards while protecting local ecosystems.</p>
    </div>

    <div className="adv-card">
      <h3>♻️ Resource Efficiency</h3>
      <p>Optimizes water reuse and reduces waste for sustainable operations.</p>
    </div>

    <div className="adv-card">
      <h3>⚡ Operational Reliability</h3>
      <p>Delivers consistent performance with minimal downtime and reduced maintenance costs.</p>
    </div>

    <div className="adv-card">
      <h3>💰 Cost Savings</h3>
      <p>Provides long-term financial efficiency through smart, scalable solutions.</p>
    </div>
  </div>
</section>

      {/* Technical Specifications */}
      <section className="specs">
  <h2>Technical Specifications</h2>

  <div className="tabs">
    <button>⚙️ Capacity Range</button>
    <button>🧪 Treatment Technologies</button>
    <button>💧 Output Standards</button>
  </div>

  <div className="tab-content">
    <div className="tab-panel">
      <h3>⚙️ Capacity Range</h3>
      <p>
        Systems available from <strong>10 m³/hr</strong> for small facilities up to
        <strong>1000 m³/hr</strong> for large industrial plants, ensuring scalability.
      </p>
    </div>

    <div className="tab-panel">
      <h3>🧪 Treatment Technologies</h3>
      <p>
        Incorporates <strong>biological treatment</strong>, <strong>membrane filtration</strong>, and <strong>advanced oxidation</strong> for maximum efficiency and adaptability.
      </p>
    </div>

    <div className="tab-panel">
      <h3>💧 Output Standards</h3>
      <p>
        Produces water with <strong>TSS &lt; 5 ppm</strong>, <strong>BOD &lt; 10 ppm</strong>, and <strong>turbidity &lt; 1 NTU</strong>, meeting international reuse and discharge norms.
      </p>
    </div>
  </div>
</section>

      {/* Call-to-Action Section */}
      <section className="cta-section">
  <h2>Safeguard Water, Safeguard the Future</h2>
  <p className="cta-subtext">
    Discover sustainable sewage treatment solutions that protect ecosystems and reduce operational costs.
  </p>
  <div className="cta-buttons">
    <Link to="/contact"><button className="cta primary">Request a Quote</button></Link>  
    <a href="/Brochure.pdf" download className="btn-secondary">Download Brochure</a>
  </div>
</section>
    </div>
  );
}